/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'

interface FormValues {
  ClosingMessage?: any,
  ClosingStatementURL?: any,
  Enabled?: boolean
}

export interface CongressContextInterface {
  congress?: any;
  setCongress: (congress?: any, config?: any) => void;
  isLoading: boolean;
  disabled: boolean;
  status: FormValues;
}

const CongressContext = React.createContext<CongressContextInterface | null>(null)

export default CongressContext
